import React, { Fragment } from 'react'
import { ControlLabel } from 'react-bootstrap'
import PropTypes from 'prop-types'

export const VideoChapter = props => {
  return (
    <Fragment>
      <p className="mt-4 mb-1">{props.chapter[0]}</p>
      {props.chapter[1].map(ch => (
        <div className="mb-1" key={ch[1]}>
          <input
            value={ch[0]}
            type="checkbox"
            className="mr-3"
            onChange={e => props.handleChange(e)}
          />
          <ControlLabel>{ch[1] === '' ? 'No Title' : ch[1]}</ControlLabel>
        </div>
      ))}
    </Fragment>
  )
}

VideoChapter.propTypes = {
  chapter: PropTypes.array,
  handleChange: PropTypes.func,
}
